/**
 * KeyIcon — Key Insight callout icon. Navy background, coral key glyph
 * (bow + shaft + two teeth).
 *
 * Cross-palette pairing (coral on navy); the heaviest of the four callouts
 * per `/shared/design-tokens.v2.json` callout.key-insight block.
 *
 * Deliberately a key, NOT a star or sparkle — the brand-discipline rules
 * in `/policy/brand-discipline.md` §1 forbid celestial-adjacent imagery.
 * If a future variant tries to substitute a star, route back to Russ.
 *
 * Production SVG landed 2026-05-04 in /design/icons/callout-keyinsight-key.svg.
 * Geometry preserved from the v10 mockup reference; primitives + accessibility
 * tags. Two teeth — longer (length 4) closer to the bow, shorter (length 3)
 * at the end — match the production reference.
 */

import IconCircle from "./IconCircle.jsx";

export default function KeyIcon({ size = 38 }) {
  const stroke = "var(--ppr-color-accent-coral)";
  return (
    <IconCircle size={size} bg="var(--ppr-color-accent-navy)">
      <svg
        width={size * 0.55}
        height={size * 0.55}
        viewBox="0 0 24 24"
        fill="none"
        role="img"
        aria-label="Key insight"
      >
        {/* Bow (the round end of the key) */}
        <circle cx="8" cy="12" r="4" stroke={stroke} strokeWidth="2.25" />
        {/* Shaft */}
        <line
          x1="12"
          y1="12"
          x2="22"
          y2="12"
          stroke={stroke}
          strokeWidth="2.25"
          strokeLinecap="round"
        />
        {/* Tooth 1 (longer) */}
        <line
          x1="18"
          y1="12"
          x2="18"
          y2="16"
          stroke={stroke}
          strokeWidth="2.25"
          strokeLinecap="round"
        />
        {/* Tooth 2 (shorter, at the end) */}
        <line
          x1="21"
          y1="12"
          x2="21"
          y2="15"
          stroke={stroke}
          strokeWidth="2.25"
          strokeLinecap="round"
        />
      </svg>
    </IconCircle>
  );
}
